exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-feedback[data-v-40c53fbc],.invalid-feedback span[data-v-40c53fbc]{display:block}.search-wrapper label[data-v-40c53fbc]{position:relative;width:100%}.close[data-v-40c53fbc]{position:absolute;top:60%;right:20px;width:8px;height:8px;opacity:.3;cursor:pointer}.close[data-v-40c53fbc]:hover{opacity:1}.close[data-v-40c53fbc]:after,.close[data-v-40c53fbc]:before{position:absolute;left:4px;content:\" \";height:12px;width:2px;background-color:#333}.close[data-v-40c53fbc]:before{transform:rotate(45deg)}.close[data-v-40c53fbc]:after{transform:rotate(-45deg)}", ""]);

// exports
